import { render, staticRenderFns } from "./CNPage.vue?vue&type=template&id=230cbf5e&scoped=true"
import script from "./CNPage.vue?vue&type=script&lang=js"
export * from "./CNPage.vue?vue&type=script&lang=js"
import style0 from "./CNPage.vue?vue&type=style&index=0&id=230cbf5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230cbf5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230cbf5e')) {
      api.createRecord('230cbf5e', component.options)
    } else {
      api.reload('230cbf5e', component.options)
    }
    module.hot.accept("./CNPage.vue?vue&type=template&id=230cbf5e&scoped=true", function () {
      api.rerender('230cbf5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/CNPage.vue"
export default component.exports